























































































import Vue from 'vue';
import validate from '@/utils/validate';
import { Component, Prop } from 'vue-property-decorator';
import { TTeacherAddForm } from '@/types/views/school';
import { TRules } from '@/types/utils.d.ts'
import { addTeacher } from '@/api/school';
@Component({})
export default class Add extends Vue {
  @Prop({ type: Function, required: false }) reload: any;
  private centerDialogVisible = false;
  private form: TTeacherAddForm = {
    phone: '',
    sex: '男',
    avatarImageURL: '',
    email: '',
    teacherName: '',
    layer: '',
    age: '',
    education: '',
    teacherDes: ''
  };
  private rules: TRules = {
    phone: [
      {
        required: true,
        validator: validate.validatorPhone_rule,
        trigger: 'blur'
      }
    ],
    email: [
      {
        required: true,
        validator: validate.validatorEmail_rule,
        trigger: 'blur'
      }
    ],
    teacherName: [
      { required: true, message: '老师名字不能为空', trigger: 'blur' }
    ],
    layer: [{ required: true, message: '老师等级不能为空', trigger: 'blur' }],
    education: [
      { required: true, message: '教育程度不能为空', trigger: 'blur' }
    ],
    age: [
      { required: true, validator: validate.validatorNumber_rule, trigger: 'blur' }
    ],
    sex: [{ required: true }],
    avatarImageURL: [{ required: true }]
  };
  private onSubmit(formName: string) {
    (this.$refs[formName] as any).validate(async (valid: boolean) => {
      if (valid) {
        this.addTeacher(this.form);
      } else {
        this.$message.warning('请填写完整');
        return false;
      }
    });
  }
  private async addTeacher(form: TTeacherAddForm) {
    try {
      const res: any = await addTeacher(form);
      if (res) {
        this.centerDialogVisible = false;
        this.$message.success('添加成功');
        this.reload();
      } else {
        this.$message.error('添加失败');
      }
    } catch (e) {
      this.$message.error(e);
    }
  }
  private openUpload() {
    (this.$refs.dialog as any).visible = true;
  }
  private deleteUpload() {
    this.form.avatarImageURL = '';
  }
  private handleConfirm(url: string) {
    this.form.avatarImageURL = url;
    console.log(url);
  }
}
